// extracted by mini-css-extract-plugin
export default {"modal":"R_-z","modalContent":"S_-z","footer":"T_-z","cancelBtn":"U_-z","disabled":"V_-z","formWrapper":"W_-z","fade":"X_-z","fade-in":"Y_-z","iframe":"Z_-z"};